import { useState, useRef, useEffect } from "react";
import styles from "./FilterBar.module.css";

import MainButton from "../MainButton/MainButton";
import FilterDropdown from "../FilterDropdown/FilterDropdown";

import dropMenu from "../../assets/svgs/dropMenu.svg";
import dropMenuHover from "../../assets/svgs/dropMenuHover.svg";
import dropMenuSelected from "../../assets/svgs/dropMenuSelected.svg";
import arrowDown from "../../assets/svgs/grey_menu_arrow.svg";
import arrowDownHover from "../../assets/svgs/arrow-down-hover.svg";
import arrowDownSelected from "../../assets/svgs/arrow-down-selected.svg";
import departmentIcon from "../../assets/svgs/department.svg";
import departmentIconHover from "../../assets/svgs/departmentHover.svg";
import departmentIconSelected from "../../assets/svgs/departmentSelected.svg";
import checkmark from "../../assets/svgs/checkmark.svg";
import searchIcon from "../../assets/svgs/search.svg";
import closeIcon from "../../assets/svgs/close.svg";
import exitIcon from "../../assets/svgs/exit_icon.svg";
import exitIconHover from "../../assets/svgs/exit_icon_hover.svg";

const FilterBar = ({ orderOption, onOrderChange, users, onFilteredUsersChange, isMobile, initialDepartment, }) => {
  const [searchText, setSearchText] = useState("");
  const [showOrderDropdown, setShowOrderDropdown] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isDeptHovered, setIsDeptHovered] = useState(false);;
  const [showDeptDropdown, setShowDeptDropdown] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(
    initialDepartment || "Comunicación"
  );
  const [isExitHovered, setIsExitHovered] = useState(false);
  const dropdownRef = useRef(null);
  const deptDropdownRef = useRef(null);

  const normalizeText = (text) =>
    text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOrderDropdown(false);
      }
      if (deptDropdownRef.current && !deptDropdownRef.current.contains(event.target)) {
        setShowDeptDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!showOrderDropdown) {
      setIsHovered(false);
    }
    if (!showDeptDropdown) {
      setIsDeptHovered(false);
    }
  }, [showOrderDropdown, showDeptDropdown]);

  useEffect(() => {
    if (initialDepartment) {
      setSelectedDepartment(initialDepartment);
    }
  }, [initialDepartment]);

  useEffect(() => {
    if (users && Array.isArray(users)) {
      const filtered = users.filter((user) => {
        const matchName = normalizeText(user.Nombre).includes(normalizeText(searchText));
        const matchDept = selectedDepartment
          ? user.Departamentos?.includes(selectedDepartment)
          : true;
        return matchName && matchDept;
      });
      onFilteredUsersChange(filtered);
    }
  }, [searchText, users, selectedDepartment, onFilteredUsersChange]);

  const toggleOrderDropdown = () => {
    setShowOrderDropdown((prev) => !prev);
  };

  const handleSelectOrder = (value) => {
    onOrderChange(value);
    setShowOrderDropdown(false);
  };

  const handleSelectDepartment = (dept) => {
    setSelectedDepartment(dept);
    setShowDeptDropdown(false);
  };

  const orderLabels = {
    priority: "Prioridad",
    maxLoad: "Mayor carga",
    minLoad: "Menor carga",
    alphabetical: "Alfabético",
    notesCount: "Nº comentarios",
  };

  const allDepartments = ["Comunicación", "Informática", "Diseño", "Administración"];

  const orderOptions = Object.entries(orderLabels).map(([value, label]) => ({
    value,
    label,
  }));

  const departmentOptions = allDepartments.map((dept) => ({
    value: dept,
    label: dept,
  }));


  const currentLabel = orderLabels[orderOption] || "Prioridad";

  let leftIcon = dropMenu;
  let rightIcon = arrowDown;
  if (showOrderDropdown) {
    leftIcon = dropMenuSelected;
    rightIcon = arrowDownSelected;
  } else if (isHovered) {
    leftIcon = dropMenuHover;
    rightIcon = arrowDownHover;
  }

  return (
    <div className={`${styles.filterBar} ${isMobile ? styles.filterBarMobile : ""}`}>

      <div className={`${isMobile ? styles.searchInputWrapperMobile : styles.searchInputWrapper}`}>
        <img
          src={searchIcon}
          alt="Buscar"
          className={isMobile ? styles.searchIconMobile : styles.searchIcon}
        />
        <input
          type="text"
          placeholder="Buscar..."
          className={`${styles.searchInput} ${isMobile ? styles.searchInputMobile : ""}`}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        {searchText && (
          <button
            type="button"
            className={`${styles.clearButton} ${isMobile ? styles.clearButtonMobile : ""}`}
            onClick={() => setSearchText("")}
          >
            <img
              src={closeIcon}
              alt="Limpiar búsqueda"
              className={`${styles.clearIcon} ${isMobile ? styles.clearIconMobile : ""}`}
            />
          </button>
        )}
      </div>

      {isMobile ? (
        <div className={styles.mobileColumn}>
          <div className={styles.mobileDropdownsRow}>
            <div className={styles.orderDropdownWrapperMobile}>
              <FilterDropdown
                label="Departamentos"
                options={departmentOptions}
                selectedValue={selectedDepartment}
                onSelect={setSelectedDepartment}
                leftIcon={departmentIcon}
                leftIconHover={departmentIconHover}
                leftIconActive={departmentIconSelected}
                rightIcon={arrowDown}
                rightIconHover={arrowDownHover}
                rightIconActive={arrowDownSelected}
                checkIcon={checkmark}
                wrapperClassName={styles.orderDropdownWrapperMobile}
                isMobile
              />
            </div>

            <div className={styles.orderDropdownWrapperMobile}>
              <FilterDropdown
                label="Prioridad"
                options={orderOptions}
                selectedValue={orderOption}
                onSelect={onOrderChange}
                leftIcon={dropMenu}
                leftIconHover={dropMenuHover}
                leftIconActive={dropMenuSelected}
                rightIcon={arrowDown}
                rightIconHover={arrowDownHover}
                rightIconActive={arrowDownSelected}
                checkIcon={checkmark}
                wrapperClassName={styles.orderDropdownWrapperMobile}
                isMobile
              />
            </div>
          </div>

          <div className={styles.mobileBelowRow}>
            <MainButton
              variant="light"
              rightIcon={exitIcon}
              rightIconHover={exitIconHover}
              rightIconAlt="Salidas equipo"
              rightIconClassName={styles.exitIcon}
              onClick={() => {
                window.location.href = "/admin/salidas";
              }}
            >
              Salidas equipo
            </MainButton>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.orderDropdownWrapper}>
            <FilterDropdown
              label="Departamentos"
              options={departmentOptions}
              selectedValue={selectedDepartment}
              onSelect={setSelectedDepartment}
              leftIcon={departmentIcon}
              leftIconHover={departmentIconHover}
              leftIconActive={departmentIconSelected}
              rightIcon={arrowDown}
              rightIconHover={arrowDownHover}
              rightIconActive={arrowDownSelected}
              checkIcon={checkmark}
              wrapperClassName={styles.orderDropdownWrapper}
            />
          </div>

          <div className={styles.orderDropdownWrapper}>
            <FilterDropdown
              label="Prioridad"
              options={orderOptions}
              selectedValue={orderOption}
              onSelect={onOrderChange}
              leftIcon={dropMenu}
              leftIconHover={dropMenuHover}
              leftIconActive={dropMenuSelected}
              rightIcon={arrowDown}
              rightIconHover={arrowDownHover}
              rightIconActive={arrowDownSelected}
              checkIcon={checkmark}
              wrapperClassName={styles.orderDropdownWrapper}
            />
          </div>

          <div className={styles.orderDropdownWrapper}>
            <MainButton
              variant="light"
              rightIcon={exitIcon}
              rightIconHover={exitIconHover}
              rightIconAlt="Salidas equipo"
              rightIconClassName={styles.exitIcon}
              onClick={() => {
                window.location.href = "/admin/salidas";
              }}
            >
              Salidas equipo
            </MainButton>
          </div>
        </>
      )}
    </div>
  );
};

export default FilterBar;
